type RequestInitConfig = Omit<RequestInit, "method">;

export type HTTPResponse<T> = Omit<Response, "json"> & { json(): Promise<T> };

export abstract class HTTPClient {
  protected abstract host?: string;

  protected getRequestUrl(url: string, config?: { noSlash?: boolean }) {
    if (!this.host) {
      throw new Error("No host variable set. Check env configuration");
    }
    const fullUrl = `${this.host}${config?.noSlash ? "" : "/"}${url}`;
    const [protocol, path] = fullUrl.split("://");
    return `${protocol}://${path.replace(/[/]+/g, "/")}`;
  }

  protected abstract request<T>(
    url: string,
    config: RequestInit,
  ): Promise<HTTPResponse<T>>;

  public async get<T>(url: string) {
    return this.request<T>(url, {});
  }

  public async post<T>(url: string, config?: RequestInitConfig) {
    return this.request<T>(url, { ...config, method: "POST" });
  }

  public async put<T>(url: string, config?: RequestInitConfig) {
    return this.request<T>(url, { ...config, method: "PUT" });
  }

  public async patch<T>(url: string, config?: RequestInitConfig) {
    return this.request<T>(url, { ...config, method: "PATCH" });
  }

  public async delete<T>(url: string, config?: RequestInitConfig) {
    return this.request<T>(url, { ...config, method: "DELETE" });
  }
}
